import React, { Suspense } from "react";
import FavoriteProductEditModal from "@/features/my-account/favorite-product-edit-modal";

interface Props {
  isProductEditOpen: boolean;
  setIsProductEditOpen: (isOpen: boolean) => void;
}

function FavoriteProductEditModalWrapper({
  isProductEditOpen,
  setIsProductEditOpen,
}: Props) {
  return (
    <>
      {isProductEditOpen && (
        <Suspense>
          <FavoriteProductEditModal
            isOpen={isProductEditOpen}
            onClose={() => setIsProductEditOpen(false)}
          />
        </Suspense>
      )}
    </>
  );
}

export default FavoriteProductEditModalWrapper;
